var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarContributors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53665 13.02L10.152 12.7653M10.152 11.2347L9.53665 10.9793M11.2346 10.152L10.9793 9.53667M11.2346 13.848L10.9793 14.464M12.7653 10.152L13.0206 9.53667M13.02 14.464L12.7653 13.848M1.33331 14C1.33339 13.1606 1.53158 12.3332 1.91175 11.5848C2.29193 10.8365 2.84336 10.1885 3.5212 9.69345C4.19903 9.19842 4.98414 8.87037 5.81267 8.73597C6.6412 8.60157 7.48975 8.66463 8.28931 8.92M13.848 11.2347L14.464 10.9793M13.848 12.7653L14.464 13.0207M9.99998 5.33333C9.99998 7.17428 8.5076 8.66667 6.66665 8.66667C4.8257 8.66667 3.33331 7.17428 3.33331 5.33333C3.33331 3.49238 4.8257 2 6.66665 2C8.5076 2 9.99998 3.49238 9.99998 5.33333ZM14 12C14 13.1046 13.1045 14 12 14C10.8954 14 9.99998 13.1046 9.99998 12C9.99998 10.8954 10.8954 10 12 10C13.1045 10 14 10.8954 14 12Z",
    stroke: "#444444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarContributors);
export default __webpack_public_path__ + "static/media/sidebar-contributors.216ef591ca7337839c49666dbb365fc7.svg";
export { ForwardRef as ReactComponent };